import PlannedProjectList from '@containers/project/PlannedProjectList';
import { useEffect } from 'react';

const PlannedProjectListPage = () => {
  useEffect(() => {}, []);

  return <PlannedProjectList />;
};

export default PlannedProjectListPage;
